import React, { useContext } from 'react';

interface ISsrContext {
  redirect?: (url: string) => void;
}

const SsrContext = React.createContext<ISsrContext>({
  redirect: undefined,
});

export const useSsrContext = () => useContext(SsrContext);

interface SsrProviderOpts {
  children?: React.ReactNode;
  redirect?: (url: string) => void;
}

export const SsrProvider = ({ children, redirect }: SsrProviderOpts) => {
  return (
    // @ts-ignore
    <SsrContext.Provider
      value={{
        redirect,
      }}
    >
      {children}
    </SsrContext.Provider>
  );
};
